module.exports = __webpack_public_path__ + "img/procreate-mobile_en.147f723.jpg";